import React from "react";
import Spinner from '../assets/gifs/gif_spinner.gif'

const Loading = () => {
  return (
      <div className="ld-wrp">
        <img src={Spinner} alt="loading"/>
      </div>
  )
}

export default Loading;

